module.exports = __webpack_public_path__ + "img/pump-south-liquid.7bdf9c74.png";